<template>
  <modal-base :roundBorder="false" class="tariff-was-activated">
    <div class="tariff-was-activated__wrap">
      <div class="tariff-was-activated__drone"></div>
      <div class="tariff-was-activated__title">{{tariff.nickname}} plan activated</div>
      <div class="tariff-was-activated__body">
        <div class="tariff-was-activated__subtitle">
          {{ tariff.type === 'free' ? 'You have free quotes now!' : 'You have next quotes now:' }}
        </div>

        <table class="tariff-was-activated__quotes">
          <tr class="tariff-was-activated__quote">
            <td class="tariff-was-activated__quote-val"><icon-base class="infinity-icon" red><icon-infinity /></icon-base></td>
            <td class="tariff-was-activated__quote-name">platform notifications</td>
          </tr>
          <tr class="tariff-was-activated__quote">
            <td class="tariff-was-activated__quote-val">{{tariff.limitSMS}}</td>
            <td class="tariff-was-activated__quote-name">SMS notifications</td>
          </tr>
          <tr class="tariff-was-activated__quote">
            <td class="tariff-was-activated__quote-val">{{tariff.limitEmail}}</td>
            <td class="tariff-was-activated__quote-name">email notifications</td>
          </tr>
          <tr class="tariff-was-activated__quote">
            <td class="tariff-was-activated__quote-val">{{tariff.limitPush}}</td>
            <td class="tariff-was-activated__quote-name">push notifications</td>
          </tr>
          <tr class="tariff-was-activated__quote">
            <td class="tariff-was-activated__quote-val">{{tariff.limitWebhook}}</td>
            <td class="tariff-was-activated__quote-name">webhook notifications</td>
          </tr>
        </table>
        <div class="tariff-was-activated__buttons">
          <button-el class="btn btn_got-it" :disabled="inProgress" @click="dismiss(NotificationsKeys.tariffWasActivated)" black>Understand</button-el>
          <button-el
            red
            v-if="!isSubscriptionManagement"
            class="btn btn_subscr"
            :disabled="inProgress"
            @click="clickSubscriptionsBtn(NotificationsKeys.tariffWasActivated)"
          >Subscriptions</button-el>
          <round-btn small @click="dismiss(NotificationsKeys.tariffWasActivated)" class="btn btn_got-it_round ">
            <icon-base red :disabled="inProgress">
              <icon-check />
            </icon-base>
          </round-btn>
        </div>
      </div>
    </div>
  </modal-base>
</template>

<script>
import { mapActions } from 'vuex';
import ModalBase from 'Common/ModalBase';
import NotificationsKeys from 'src/models/NotificationsKeys';
import { IconInfinity, IconCheck } from 'Icons';
import userNotitficationsMixin from './userNotitficationsMixin';

export default {
  mixins: [
    userNotitficationsMixin,
  ],
  components: {
    ModalBase,
    IconInfinity,
    IconCheck,
  },
  props: {
    tariff: Object,
  },
  data: () => ({
    NotificationsKeys,
  }),
  computed: {
    isSubscriptionManagement() {
      return this.$route.meta.isSubscriptionManagement;
    },
  },
  mounted() {
    if (this.isSubscriptionManagement) {
      this.updateQuotasInfo();
      this.updateCurrentTariff();
    }
  },
  methods: {
    ...mapActions('subscription', ['updateQuotasInfo', 'updateCurrentTariff']),
  },
};
</script>

<style lang="scss" scoped>
$max-width: 380px;
.tariff-was-activated {
  &__wrap {
    background: $white-color2;
    width: $max-width;
    position: relative;
  }
  &__title {
    @include font(24px, $black-color1, 500);
    padding: 26px 30px;
    border-bottom: 1px solid $white-color5;
  }
  &__drone {
    @include attachImage('drone2', 380px, 370px);
    max-width: 100%;
    background-position: right -3px;
    position: absolute;
    right: 0;
  }
  &__body {
    padding: 32px 30px;
    z-index: 2;
    position: relative;
  }
  &__subtitle {
    @include font(16px, $black-color1, 500);
  }
  &__quotes {
    margin-top: 12px;
    margin-left: -6px;
  }
  &__quote {
    height: 23px;
  }
  &__quote-name {
    @include font(14px, $black-color1, normal);
    vertical-align: middle;
    padding-left: 16px;
  }
  &__quote-val {
    @include font(14px, $red-color3, 600);
    text-align: center;
    vertical-align: middle;
  }
  &__buttons {
    margin-top: 28px;
  }
}
.btn_subscr {
  margin-left: 16px;
}
.infinity-icon {
  transform: scale(0.85);
}

.btn_got-it_round {
  @include incrSelectorWeight(1) {
    display: none;
  }
}

$bp: $max-width + ($modal-side-margin * 2) - 1px;
@media screen and (max-width: $bp) {
  .btn {
    &_got-it {
      display: none;
    }
  }
  .tariff-was-activated__wrap {
    width: 100vw;
    max-width: calc(100vw - #{$modal-side-margin});
  }
  .btn_got-it_round {
    @include incrSelectorWeight(1) {
      display: inline-flex;
      margin-left: 30px;
      vertical-align: middle;
    }
  }
  .btn_subscr {
    margin-left: 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/userNotifications/TarrifWasActivated.vue